import { IAgentHours } from "../types/hours";
import { defaultMenuModuleFormConfig } from "./modules/menu";
import {
  defaultBaseOrderingModuleConfig,
  defaultPickupModuleConfig,
  defaultDeliveryModuleConfig,
} from "./modules/ordering";
import { defaultReservationModuleConfig } from "./modules/reservation";
import { defaultVoicemailModuleConfig } from "./modules/voicemail";
import { emptyHolidayHoursConfig } from "@loman/utils";

export const emptyHours: IAgentHours = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [],
};

export const defaultTwilioOverride = {
  enabled: false,
};

export const defaultBaseAgentFormValues = {
  // Core fields
  type: "PICKUP" as const,
  name: "",
  placeId: "",
  timezone: null,
  hours: emptyHours,
  hoursOrdering: null,
  accountId: "",
  phoneNumber: undefined,

  // Direct prompting
  greetingMessageOpen: "",
  greetingMessageOrderingClosed: "",
  greetingMessageClosed: "",
  hubspotDealId: undefined,
  prompt: "",

  // Action triggers
  transfers: [{ key: "", value: "" }],
  messages: [{ key: "", value: "" }],

  // Geographic consent
  twoPartyConsent: true,

  pos: "stream" as const,

  // Toast
  toastUrl: "",
  toastLocationId: "",

  // Square
  squareMerchantId: "",
  squareLocationId: "",
  squareAccessToken: "",
  squareRefreshToken: "",

  // Clover
  cloverMerchantId: "",
  cloverAccessToken: "",
  cloverRefreshToken: "",
  cloverOrderTypeId: "",

  // Kwick
  kwickMerchantKey: "",
  kwickMerchantToken: "",

  // SpotOn
  spotOnLocationId: "",
  spotOnMenuId: "",

  // Skytab
  skytabLocationId: "",
  skytabOrderTypeRef: "",

  // Foodtec
  foodtecBaseUrl: "",
  foodtecMenuAuth: "",
  foodtecCheckoutAuth: "",
  foodtecOrderAuth: "",
  foodtecOrderTypes: [],

  menuModuleConfig: defaultMenuModuleFormConfig,

  ...defaultBaseOrderingModuleConfig,

  // Root-level prep times (new)
  pickupPrepTime: 25,
  deliveryPrepTime: 25,
  customPrepTimeEnabled: false,
  customPrepTimeHours: emptyHours,

  // Holiday hours
  holidayHours: emptyHolidayHoursConfig,

  // Twilio override
  twilioOverride: defaultTwilioOverride,

  ...defaultPickupModuleConfig,

  ...defaultDeliveryModuleConfig,

  ...defaultReservationModuleConfig,

  ...defaultVoicemailModuleConfig,
};

// Default values for creating a new agent
export const defaultCreateAgentFormValues = {
  ...defaultBaseAgentFormValues,
  voiceId: null,
};

// Default values for patching an existing agent
export const defaultPatchAgentFormValues = {
  ...defaultBaseAgentFormValues,
  id: "",
  slug: "",
  hoursLoman: null,
  disallowClosedTransfers: false,
  faqs: [],
  allowAnon: false,
};
